import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import styles from "./ServicesSection.module.css";

const defaultItems = [
  {
    title: "Accurate Claim Creation",
    text: "We organize billing workflows carefully so claims are created with greater consistency, cleaner submission quality, and fewer preventable issues.",
  },
  {
    title: "Revenue-Focused Oversight",
    text: "Our process supports clearer reporting, stronger follow-up visibility, and better decision-making around collections and reimbursement performance.",
  },
  {
    title: "Stronger Patient Experience",
    text: "Cleaner billing operations help reduce confusion, improve communication, and create a smoother experience for both teams and patients.",
  },
  {
    title: "Compliance Confidence",
    text: "We stay aligned with industry standards and documentation expectations so your workflows remain more dependable and easier to manage.",
  },
];

export default function ServicesSection({
  kicker = "Why Choose Us",
  heading = "Advantages of PSP Medical Billing Services",
  description = "At Physicians Success Partners, we help make sure your practice gets paid correctly by providing expert billing and coding services. Our team carefully translates medical procedures and diagnoses into accurate billing codes, helping reduce mistakes and support a faster payment cycle.",
  buttonLabel = "Let's Connect",
  buttonLink = "/contact-us",
  items = defaultItems,
}) {
  const sectionRef = useRef(null);
  const cardsRef = useRef(null);

  useEffect(() => {
    function handleWheel(event) {
      if (window.innerWidth <= 1080) {
        return;
      }

      const section = sectionRef.current;
      const cardsGrid = cardsRef.current;

      if (!section || !cardsGrid) {
        return;
      }

      const rect = section.getBoundingClientRect();
      const sectionActive = rect.top <= 120 && rect.bottom >= window.innerHeight * 0.45;
      const canScrollDown =
        event.deltaY > 0 &&
        cardsGrid.scrollTop + cardsGrid.clientHeight < cardsGrid.scrollHeight - 1;
      const canScrollUp = event.deltaY < 0 && cardsGrid.scrollTop > 0;

      if (sectionActive && (canScrollDown || canScrollUp)) {
        event.preventDefault();
        cardsGrid.scrollTop += event.deltaY;
      }
    }

    window.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      window.removeEventListener("wheel", handleWheel);
    };
  }, []);

  return (
    <section ref={sectionRef} className={styles.section}>
      <div className={`container ${styles.shell}`}>
        <div className={styles.contentPanel}>
          {/* {kicker ? <span className={styles.kicker}>{kicker}</span> : null} */}
          <h2>{heading}</h2>
          <p className={styles.description}>{description}</p>

          {buttonLabel ? (
            <Link to={buttonLink} className={styles.ctaButton}>
              {buttonLabel}
            </Link>
          ) : null}
        </div>

        <div ref={cardsRef} className={styles.cardsGrid}>
          {items.map((item, index) => (
            <article
              key={item.title}
              className={`${styles.card} ${index % 2 === 1 ? styles.cardRaised : ""}`}
            >
              <span className={styles.cardNumber}>
                {String(index + 1).padStart(2, "0")}
              </span>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
